import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: InitialConfiguratorRightsState = {
  nightMode: false,
  individualHouse: false,
}

export type InitialConfiguratorRightsState = {
  nightMode: boolean
  individualHouse: boolean
}

export const configuratorRightsSlice = createSlice({
  name: 'configuratorRights',
  initialState,
  reducers: {
    setUserRights: (
      state,
      { payload }: PayloadAction<InitialConfiguratorRightsState>
    ) => {
      state.individualHouse = payload.individualHouse
      state.nightMode = payload.nightMode
    },
  },
})

// Component
export const { setUserRights } = configuratorRightsSlice.actions

// Store
export const configuratorRightReducer = configuratorRightsSlice.reducer
